import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgElo({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.007 2.731a9.276 9.276 0 100 18.552 9.276 9.276 0 000-18.552z"
        fill="#050013"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33 11.316l-2.761 1.19a1.581 1.581 0 012.76-1.19zM8.143 9.597c1.303 0 2.395.902 2.687 2.115l-1.114.487v-.003l-1.14.5-2.733 1.196a2.763 2.763 0 012.3-4.295z"
        fill="#FFF200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.075 14.338c-.99.939-2.3 1.03-3.45.333l.65-.989c.655.392 1.313.328 1.973-.19l.827.845zM11.2 13.653l-.007-5.226h.99v5.085c0 .049.006.092.07.117l.861.335-.388 1.009-1.009-.427c-.382-.162-.516-.397-.517-.893z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.787 14.313a2.731 2.731 0 01-4.324-3.187l1.031.547a1.566 1.566 0 002.512 1.776l.781.864z"
        fill="#A91C2C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.896 9.54a2.731 2.731 0 012.472 3.892l-1.031-.547a1.566 1.566 0 00-2.498-1.77l-.781-.864a2.721 2.721 0 011.838-.711z"
        fill="#FFF200"
      />
    </svg>
  )
}

export default SvgElo
